import { QueryKey } from "@tanstack/react-query";
import { QUERY_CACHE_PERIOD } from "../../constants/queryConstants";
import { ServicePath } from "../../constants/apiConstants";
import { FetchQueryParams, getFetchQuery, useFetchQuery } from "../core/rest/useFetchQuery";
import { Entity } from "./entity.types";

const getParams = (
  entitySubdomain: string | undefined,
): {
  queryKey: QueryKey;
  url: string;
  options: FetchQueryParams<Entity, Entity>["options"];
} => ({
  queryKey: ["entities", entitySubdomain],
  url: `${ServicePath.EntitiesV1}/${entitySubdomain}`,
  options: { enabled: !!entitySubdomain, staleTime: QUERY_CACHE_PERIOD.MEDIUM },
});

export const getEntityQuery = ({
  entitySubdomain,
  getAccessToken,
}: {
  entitySubdomain: string | undefined;
  getAccessToken?: () => Promise<string>;
}) => {
  return getFetchQuery<Entity>({
    ...getParams(entitySubdomain),
    getAccessToken,
  });
};

export function useGetEntity(entitySubdomain: string | undefined) {
  return useFetchQuery<Entity>({
    ...getParams(entitySubdomain),
  });
}
